var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white-900 h-full"},[_c('div',{staticClass:"px-0 mx-auto relative h-full flex"},[_c('base-logo',{staticClass:"absolute top-4 left-8"}),_c('auth-info',{staticClass:"flex-shrink-0"}),_c('auth-sign-in-form')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }